import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { ControlPermission } from '@pages/modules-permission/interfaces/controlPermission';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class ControlesService {
  private _url = environment.apiBaseUrl + 'api/ControlPermission';
  constructor(private _http: HttpClient) {}

  read(formId: number): Observable<Response> {
    let url: string = this._url + '/' + formId ;
    return this._http.get<Response>(url);
  }

  readControls(formId: number): Observable<Response> {
    let url: string = this._url + '/GetControls/' + formId ;
    return this._http.get<Response>(url);
  }

  readOne(moduleName: string): Observable<Response> {
    let url: string = this._url + moduleName ;
    return this._http.get<Response>(url);
  }

  create(model: ControlPermission): Observable<Response> {
    let url: string = this._url + '/Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }

  update(model: ControlPermission): Observable<Response> {
    let url: string = this._url + '/Update' ;
    return this._http.post<Response>(url, model, httpOption);
  }

  delete(model: ControlPermission): Observable<Response> {
    let url: string = this._url + '/Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }  
}
